import Contact, { ContactDto } from "../../../state/contact/models/contact"
import { Entity } from "../../../state/helpers/Entity"
import Payment, { PaymentDto } from "../../../state/payment/Payment"
import User, { UserDto } from "../../../state/user/User"

type AccountStatementAttributes = {
    userId : string,
    contactId : string,
    mergedFromContactId : string,
    type : string,
    paymentMethod : string,
    date : string,
    createdAt : string,
    paymentId : string,
    proposalHash : string,
    identifier : string,
    payment : PaymentDto
    owingBalance : string
    currency : string
    contact : ContactDto
    user : UserDto
    printUrl : string
}

export type AccountStatementDto = {
    id: string
    attributes: AccountStatementAttributes
}

export default class AccountStatement implements Entity {
    private dto: AccountStatementDto
    private contact: Contact
    private user : User
    private payment : Payment


    constructor(dto: AccountStatementDto) {
        this.dto = dto
        this.contact = new Contact(dto.attributes.contact)
        this.user = new User(this.dto.attributes.user)
        this.payment = new Payment(this.dto.attributes.payment)
    }

    isLoaded(): boolean {
        return this.dto.id != "" && this.dto.id != undefined
    }

    getId(): string {
        return this.dto.id
    }

    getDate() : string {
        return this.dto.attributes.date
    }

    getCreatedAt() : string {
        return this.dto.attributes.createdAt
    }

    getUserId() : string {
        return this.dto.attributes.userId
    }

    getIdentifier(): string {
        return this.dto.attributes.identifier
    }

    getProposalHash() : string {
        return this.dto.attributes.proposalHash
    }

    getCurrency() : string {
        return this.dto.attributes.currency
    }

    getOwingBalance() : number {
        return Number(this.dto.attributes.owingBalance)
    }

    getPaymentId() : string {
        return this.dto.attributes.paymentId
    }

    getPayment() : Payment {
        return this.payment
    }

    getContact() : Contact {
        return this.contact
    }

    getContactId() : string {
        return this.dto.attributes.contactId
    }

    getUser() : User {
        return this.user
    }

    getPrintUrl() : string {
        return this.dto.attributes.printUrl
    }

}


// WEBPACK FOOTER //
// ./src/customer/account-statement/model/AccountStatement.ts